import React, { useState } from 'react';
import SortFilter from "../SortFilter/SortFilter";
import { Grid } from "@mui/material";
import isEqual from "react-fast-compare";

interface Location {
  id: string;
  locationName: string;
}

interface FilterQuery {
  location?: Location;
  sortBy: string;
  sortDir?: string;
}

interface PayoutFilterProps {
  locations: Location[];
  onFilterChange: (input: FilterQuery) => void;
}

const PayoutFilter = ({ locations, onFilterChange }: PayoutFilterProps) => {
  const [latestQuery, setLatestQuery] = useState<Partial<FilterQuery>>({});

  const handleFilterChange = (e: FilterQuery): void => {
    const curatedQuery: FilterQuery = {
      location: e.location,
      sortBy: e.sortBy,
      sortDir: e.sortDir,
    };

    if (!isEqual(latestQuery, curatedQuery)) {
      setLatestQuery(curatedQuery);
      onFilterChange(curatedQuery);
    }
  };

  return (
    <Grid mb={2} item container direction={'column'} component={'section'}>
      <SortFilter
        filterCallback={handleFilterChange}
        locations={locations}
        sortByOption={[
          { label: 'Invoice Number', value: 'INVOICE_NUMBER' },
          { label: 'Payout Amount', value: 'PAYOUT_AMOUNT' },
          { label: 'Charge Type', value: 'TRANSACTION_TYPE' },
          { label: 'Service Dates', value: 'SERVICE_DATES' },
          { label: 'Payment Date', value: 'PAYMENT_DATE' },
          { label: 'Buyer', value: 'BUYER_COMPANY_NAME' },
          { label: 'Location', value: 'LOCATION_NAME' },
          { label: 'Booking Number', value: 'ORDER_NUMBER' },
        ]}
      />
    </Grid>
  );
};

export default PayoutFilter;
